import { connect } from 'react-redux'
import * as actions from './actions'
import { logoutUser, returnUserIfUserExists, shouldRedirectUser } from '../../layouts/LoggedIn/actions'
import { recieveLoginstatus } from '../Login/actions'
import AdminSettings from './AdminSettings'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingUserDetails: state.settings.isFetchingUserDetails,
    showWebcam: state.settings.showWebcam,
    showUploadOtion: state.settings.showUploadOtion,
    updated: state.settings.updated,
    userid: state.loginLayout.profile.userid,
    name: state.loginLayout.profile.name,
    email: state.loginLayout.profile.email,
    emailChange: state.settings.emailChange,
    emailAlreadyGot: state.settings.emailAlreadyGot,
    forceUpdate: state.settings.forceUpdate,
    accountType: state.loginLayout.profile.accountType,
    userLanguauge: state.loginLayout.profile.userLanguauge,
    timezone: state.loginLayout.profile.timezone,
    logoutSuccess: state.loginLayout.logoutSuccess,
    storageInfo: state.managePlans.storageInfo,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  closeSnackbar: () => dispatch(actions.closeSnackbar()),
  takePicture: bool => dispatch(actions.takePicture(bool)),
  uploadPicture: bool => dispatch(actions.uploadPicture(bool)),
  updateUserDetails: (
    token,
    userid,
    email,
    name,
    password,
    language,
    timezone
  ) =>
    dispatch(
      actions.updateUserDetails(
        token,
        userid,
        email,
        name,
        password,
        language,
        timezone
      )
    ),
  userUpdated: bool => dispatch(actions.userUpdated(bool)),
  deleteUser: (token, userid) => dispatch(actions.deleteUser(token, userid)),
  logoutUser: token => dispatch(logoutUser(token)),
  recieveLoginstatus: (bool, user) => dispatch(recieveLoginstatus(bool, user)),
  shouldRedirectUser: bool => dispatch(shouldRedirectUser(bool)),
  returnUserIfUserExists: token => dispatch(returnUserIfUserExists(token))
})

const AdminSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(
  AdminSettings
)

export default AdminSettingsContainer



// WEBPACK FOOTER //
// ./src/routes/Settings/AdminSettingsContainer.js